'use client'

import dynamic from 'next/dynamic'
import PhotoSliderBlockSkeleton from './PhotoSliderBlockSkeleton'

const PhotoSliderBlock = dynamic(() => import('./PhotoSliderBlock.client'), {
  ssr: false,
  loading: () => <PhotoSliderBlockSkeleton />,
})

export default PhotoSliderBlock
